import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {RiskProfileComponent} from "./components/risk-profile.component";
import {CanActivateViaAuthGuard} from '../../shared/services/auth.service';

const routes  = [{path:"riskprofile",
                  component:RiskProfileComponent,
                  canActivate:[CanActivateViaAuthGuard]
                       }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class RiskProfileRoutingModule { }
